module.exports = __webpack_public_path__ + "media/images/pages/bg_area_04-84c270ba56819e99329357b95cafad21.png";